import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import { isEmpty } from 'lodash'
import Input from './componentsFinance/common/Input'
import Button from './componentsFinance/common/Button'
import Checkbox from './common/Checkbox'
import { domain } from '../utils/request'
import { validateFile } from '../utils/validators'

export default function ManthlyResultItemForm({ onCancel, loading, initialValues, rotationId, finance, onSubmit }) {
    const [file, setFile] = useState(null)

    async function onSuccess(data) {
        const newData = new FormData()
        if (file) {
            newData.append('resultPdf', file, file.name)
        }
        newData.append('finance', finance.id)
        newData.append('result', rotationId)
        newData.append('resultComment', data.resultComment)
        newData.append('tax', data.tax)
        newData.append('inps', data.inps)
        onSubmit(newData)
    }

    return (
        <Formik onSubmit={onSuccess}
            initialValues={{
                resultComment: '',
                tax: false,
                inps: false,
                ...initialValues,
                resultPdf: initialValues && !isEmpty(initialValues.resultPdf) ? initialValues.resultPdf : '',
            }} validate={validateFile('resultPdf')}>
            {({
                setFieldValue, errors, touched,
            }) => (
                <Form>
                    <div className="columns">
                        <div className="column">
                            <Input
                                name="resultComment"
                                label="Комментарий"
                                disabled={loading}
                                placeholder="Комментарий" />
                        </div>

                    </div>
                    <Checkbox
                        name="tax"
                        label="Солиқлар тўланиши"
                        disabled={loading}
                        placeholder="Комментарий" />

                    <Checkbox
                        name="inps"
                        label="ИНПС реестр"
                        disabled={loading}
                        placeholder="Комментарий" />

                    <div className="columns">
                        <div className="column">
                            <p className="level-left">
                                Молиявий Натижа
                            </p>
                            <input
                                onChange={(e) => {
                                    setFieldValue('resultPdf', e.target.value)
                                    setFile(e.target.files[0])
                                }}
                                disabled={loading}
                                name="resultPdf"
                                type="file" />

                            {errors.resultPdf && touched.resultPdf && (
                                <div className="has-text-danger">{errors.resultPdf}</div>
                            )}
                            {initialValues ? (domain + initialValues.resultPdf).split('/').pop() : 'Файл юкланмаган'}

                        </div>
                    </div>

                    <Button
                        loading={loading}
                        text="Сохранить"
                        type="submit"
                        icon="ion-md-checkmark"
                        className="is-success" /> &nbsp;

                    <Button
                        onClick={onCancel}
                        icon="ion-md-close"
                        text="Отмена"
                        className="is-danger" />
                </Form>
            )}
        </Formik>
    )
}
